import React from "react";

const RefundPolicy = () => {
  return (
    <div className="legal-container">
      <h1>Refund Policy</h1>
      <p><strong>Last Updated:</strong> [01/03/2026]</p>

      <h2>1. Membership Payments</h2>
      <p>
        All membership payments must be paid in full before activation.
      </p>

      <h2>2. Refund Eligibility</h2>
      <ul>
        <li>Refund request must be made within 3 days of payment.</li>
        <li>Membership services must not be substantially used.</li>
      </ul>

      <h2>3. Non-Refundable Cases</h2>
      <ul>
        <li>After 3 days of payment</li>
        <li>After full access has been granted</li>
        <li>Discounted or promotional plans</li>
      </ul>

      <h2>4. Refund Processing Time</h2>
      <p>
        Approved refunds will be processed within 2-3 working days.
      </p>

      <h2>5. Contact</h2>
        <p>Contact Number:
         <a href="tel:+917879137990" className="footer__phone" style={{ color: "#555", textDecoration: "none" }}>
           📞 +917879137990
          </a>
          </p>
          <p>Email: 📧
       <a href="mailto:trakiiteam.in@gmail.com" style={{ color: "#555", textDecoration: "none" }}>  trakiiteam.in@gmail.com</a>
       </p>
    </div>
  );
};

export default RefundPolicy;